import { error } from '../../../core/js/utils/logger';
import { buildDateFromHTML5, normalizeDate } from './cartUtils';

/* eslint-disable complexity */
/**
 * Build entity object for add to cart api call.
 * Resolves all deltas between gift cards, e-gift cards,
 * inventory pools, BOPIS, and wish lists.
 * @param {object} data Required data for building entity
 * @example buildCartEntity({
 *    controls,             // object - required
 *    sku,                  // object - required
 *    eGiftCard,            // object
 *    giftCard,             // object
 *    defaultStore,         // object
 *    currentWishlistId,    // string
 * });
 * @returns {object} entity
 */
export function buildCartEntity(data) {
    if (!data.sku) {
        error('Attempting to build cart entity without sku');
    }

    const entity = {
        cartType: 'TRANSACTIONAL',
        multiLine: false,
        quantity: data.controls.quantity
    };

    if (data.eGiftCard) {
        const normalizedDeliveryDate = normalizeDate(
            data.eGiftCard.values.deliveryDate,
            data.eGiftCard.dateFormats.deliveryDate
        );
        const deliveryDate = buildDateFromHTML5(normalizedDeliveryDate);

        entity.multiLine = true;
        entity.eGiftCard = {
            deliveryDate: deliveryDate,
            message: data.eGiftCard.values.message,
            emailAddress: data.eGiftCard.values.emailAddress,
            name: data.eGiftCard.values.name
        };
    } else if (data.giftCard) {
        entity.multiLine = true;
        entity.giftCard = {
            message: data.giftCard.values.message
        };
    }

    entity.poolId = data.sku.pool;

    entity.skuId = data.sku.skuId;

    if (data.sku.productId) {
        entity.productId = data.sku.productId;
    } else if (data.sku.productIds && data.sku.productIds.length) {
        entity.productId = data.sku.productIds[0];
    }

    if (data.currentWishlistId) {
        entity.wishlist = {
            id: data.currentWishlistId
        };
    }

    if (data.navigationId) {
        entity.analytics = {
            navigationId: data.navigationId
        };
    }

    if (data.salesAttributes) {
        entity.salesAttributes = data.salesAttributes;
    }

    if (data.registryId) {
        entity.registry = {
            id: data.registryId
        };
    }

    if (data.giftWrap) {
        entity.giftWrap = data.giftWrap;
    }

    if (data.mto) {
        entity.selectedComponents = _.reduce(data.mto.components, (acc, value, key) => {
            const component = {
                type: key,
                id: value
            };
            acc.push(component);
            return acc;
        }, []);
    }

    if (data.backInStockNotification) {
        entity.cartType = data.backInStockNotification.cartType;
        entity.emailAddress = data.backInStockNotification.emailAddress;
    }

    if (data.isMarketPlace && data.offerId) {
        entity.offerId = data.offerId;
        entity.fulfillmentType = 'MARKETPLACE';
    }

    return entity;
}
/* eslint-enable complexity */

export default {
    buildCartEntity
};
